import React from 'react'
import {connect} from 'react-redux'
import {ThemeProvider} from 'styled-components'

const Provider = (props) => (
  <ThemeProvider theme={props.theme} children={props.children} />
)

const mapStateToProps = (state) => ({theme: state.theme})

export default connect(mapStateToProps)(Provider)


// WEBPACK FOOTER //
// ./assets/common/theme/Provider.js